export const NUM_FIRST_OPTIONS_SHOWN = 5;